export const getSentryDsn = () =>
	import.meta.env.VITE_SENTRY_DSN ??
	'https://fb6dbacfd864f02d0c75db8b56128d30@o186054.ingest.us.sentry.io/4508297287106560';
